import { useEffect, useState } from "react";
import { emiPaymentDetials } from "../../Api/Api";
import { useNotification } from "../Notification/NotificationContext";
import {FaTimes} from "react-icons/fa";
// import { XCircle } from "lucide-react"; // Icon for close button

const EMIHistoryModal = ({ emiId, onClose }) => {
    const [emiDetails, setEmiDetails] = useState();
    const [error, setError] = useState("");
    const { showNotification } = useNotification();

    useEffect(() => {
        const fetchPayments = async () => {
            try {
                emiPaymentDetials(emiId)
                    .then((response) => {
                        setEmiDetails(response.data);
                    })
                    .catch((error) => {
                        showNotification(error.message, "error");
                    });
            } catch (err) {
                setError("Failed to fetch payment history.");
                showNotification(err.message, "error");
            }
        };
        fetchPayments();
    }, [emiId]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6">
                {/* Header */}
                <div className="flex justify-between items-center border-b pb-4 mb-4">
                    <h2 className="text-2xl font-semibold text-gray-800">EMI Payment Details</h2>
                    <button onClick={onClose} className="text-gray-600 hover:text-gray-900 text-3xl">&times;</button>
                </div>

                {/* Error Message */}
                {error && <p className="text-red-600 font-medium">{error}</p>}

                {/* EMI Details */}
                <div className="space-y-3 text-gray-800">
                    <p><strong>Total EMI Amount:</strong> &#x20B9; {emiDetails?.totalEmiAmount}</p>
                    <p><strong>Paid Amount:</strong> &#x20B9; {emiDetails?.paidAmount}</p>
                    <p><strong>Due Amount:</strong> &#x20B9; {emiDetails?.dueAmount}</p>
                    <p><strong>Penalty:</strong> &#x20B9; {emiDetails?.penalty}</p>
                    <p><strong>Status:</strong>
                        <span className={`ml-2 px-3 py-1 text-sm font-semibold rounded-lg text-white ${emiDetails?.status === "Paid" ? "bg-green-500" : "bg-red-500"}`}>{emiDetails?.status}</span>
                    </p>
                </div>

                {/* Payment History */}
                <h3 className="text-lg font-semibold mt-5 text-gray-700">Payment History</h3>
                {emiDetails?.paymentHistory?.length > 0 ? (
                    <ul className="mt-2 border border-gray-300 rounded-lg p-3 bg-gray-100 max-h-40 overflow-y-auto">
                        {emiDetails?.paymentHistory.map((payment, index) => (
                            <li key={index} className="border-b py-2 flex justify-between text-gray-700">
                                <span>&#x20B9; {payment.amountPaid}</span>
                                <span>{new Date(payment.paymentDate).toLocaleDateString()}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-gray-500 mt-2 text-sm">No payments found.</p>
                )}

                {/* Footer */}
                <div className="flex justify-end mt-6">
                    <button onClick={onClose} className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all">Close</button>
                </div>
            </div>
        </div>
    );
};

export default EMIHistoryModal;
